// import { useState } from 'react';
// import './NavBar.scss';

// export function NavBar() {

//     const [classesStatus, setClassesStatus] = useState(['visible']);

//     function switchStatus(e, pos) {
//             let newArr = [...classesStatus];
//             console.log('event - ',e);
//             console.log('in switchStatus - ',e.currentTarget.className);
//             if (!classesStatus[pos]) {
//                 newArr.push('visible')
//                 setClassesStatus([...newArr])
//                 return;
//             }
//             if (e.currentTarget.className === 'visible') {
//                 console.log('switchStatus pass1');
//             newArr[pos] = 'hidden';
//             }
//             else {
//                 console.log('switchStatus pass2');
//                 newArr[pos] = 'visible';                
//             }
//             setClassesStatus([...newArr])

//     }

//     const returnClass = () => {
//         return classesStatus[0]
//     }

//     console.log('classesStatus - ', classesStatus);
//     console.log('classesStatus spec - ', classesStatus[0]);

//     return (
//         <div className="nav nav--visible">
//             <div className='app-nav'>
//                 <div className='navContent'>
//                     <div className='sidebar-container'>
//                         <div className='nav-ul'>

//                             <div className={classesStatus[0] || null} onClick={(e) => switchStatus(e, 0)}>
//                                 <div className='naviWrapper'>
//                                     <div className='ripple-container'>
//                                         <button>Men</button>
//                                     </div>
//                                     <div className='navi hidden'>
//                                         <div className='naviWrapper'>
//                                             <div className='ripple-container'>
//                                                 <span>Topwear</span>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className='navi hidden'>
//                                         <div className='naviWrapper'>
//                                             <div className='ripple-container'>
//                                                 <span>Bottomwear</span>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className='navi hidden'>
//                                         <div className='naviWrapper'>
//                                             <div className='ripple-container'>
//                                                 <span>Footwear</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className='navi visible'>
//                                 <div className='naviWrapper'>
//                                     <div className='ripple-container'>
//                                         <span>Beauty</span>
//                                     </div>
//                                     <div className='navi hidden'>
//                                         <div className='naviWrapper'>
//                                             <div className='ripple-container'>
//                                                 <span>Makeup</span>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className='navi hidden'>
//                                         <div className='naviWrapper'>
//                                             <div className='ripple-container'>
//                                                 <span>Babby Care</span>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className='navi hidden'>
//                                         <div className='naviWrapper'>
//                                             <div className='ripple-container'>
//                                                 <span>Masks</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }









import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './NavBar.scss';
import { getData } from '../Header/Data';
import { useProfile } from '../../Contexts/ProfileContext';
import { clearAuthStorage, clearGuestData } from '../../utils/storage';
import { getMobileAccountMenuLinks } from '../shared/accountMenuConfig';
import { fetchSiteMedia, mediaUrl } from '../../utils/siteMedia';

function ChevronIcon({ isOpen, small }) {
    const size = small ? 18 : 25;
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="#535766" className={`nav-chevron ${small ? 'nav-chevron--small' : ''}`} style={{ transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)' }}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" opacity="0.05" />
                <path fill="currentColor" d="M12.55 15.768a.786.786 0 00.041-.048l6.183-6.36a.815.815 0 000-1.128.761.761 0 00-1.095 0l-5.68 5.844-5.678-5.844a.761.761 0 00-1.095 0 .816.816 0 000 1.127l6.182 6.361A.761.761 0 0012 16a.76.76 0 00.55-.232" />
            </g>
        </svg>
    );
}

function renderCategorySubItems(cat, categoryIndex, { openSubGroupKey, toggleSubGroup, handleSubItemClick }) {
    const nodes = [];
    let leafChunk = [];
    let leafChunkKey = 0;

    const flushLeafChunk = () => {
        if (leafChunk.length === 0) return;
        nodes.push(
            <div key={`sublist-${categoryIndex}-${leafChunkKey++}`} className="nav-products-sublist">
                {leafChunk}
            </div>
        );
        leafChunk = [];
    };

    cat.subItems.forEach((subItem, subIndex) => {
        if (Array.isArray(subItem)) {
            flushLeafChunk();
            const subSectionName = subItem[0];
            const subSectionItems = subItem.slice(1);
            const subKey = `${categoryIndex}-${subIndex}`;
            const isSubOpen = openSubGroupKey === subKey;
            nodes.push(
                <div key={subKey} className="nav-products-branch nav-products-branch--sub">
                    <button
                        type="button"
                        className={`nav-products-row nav-products-row--subgroup${isSubOpen ? ' nav-products-row--active' : ''}`}
                        onClick={() => toggleSubGroup(categoryIndex, subIndex)}
                        aria-expanded={isSubOpen}
                    >
                        <span className="nav-products-row__label">{subSectionName}</span>
                        <ChevronIcon isOpen={isSubOpen} small />
                    </button>
                    <div
                        className={`nav-products-sublist nav-products-tree nav-products-tree--nested nav-products-tree--leaf-group${isSubOpen ? ' nav-products-tree--open' : ''}`}
                    >
                        {subSectionItems.map((item) => (
                            <button
                                key={item}
                                type="button"
                                className="nav-products-row nav-products-row--leaf"
                                onClick={() => handleSubItemClick(cat.sectionName, item)}
                            >
                                <span className="nav-products-row__label">{item}</span>
                            </button>
                        ))}
                    </div>
                </div>
            );
            return;
        }

        leafChunk.push(
            <button
                key={subItem}
                type="button"
                className="nav-products-row nav-products-row--leaf"
                onClick={() => handleSubItemClick(cat.sectionName, subItem)}
            >
                <span className="nav-products-row__label">{subItem}</span>
            </button>
        );
    });

    flushLeafChunk();
    return nodes;
}

export function NavBar({ headerToggle, setHeaderToggle }) {
    const navigate = useNavigate();
    const { profileData, fetchProfile } = useProfile();
    const location = useLocation();
    const [customTransition, setCustomTransition] = useState('translateX(-100%)');
    const [isClosing, setIsClosing] = useState(false);
    const [isProductsOpen, setIsProductsOpen] = useState(false);
    const [openCategoryIndex, setOpenCategoryIndex] = useState(null);
    const [openSubGroupKey, setOpenSubGroupKey] = useState(null); // 'categoryIndex-subIndex' for 3rd level
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [offerImg, setOfferImg] = useState('');
    const ref = useRef(null);

    const isGuest = localStorage.getItem('guestUser') === 'true';
    useEffect(() => {
        setIsLoggedIn(!!localStorage.getItem('token') || !!profileData?.data || isGuest);
    }, [profileData, isGuest]);

    useEffect(() => {
        let cancelled = false;
        fetchSiteMedia().then((assets) => {
            if (!cancelled) setOfferImg(mediaUrl(assets, 'sidebar.offer2') || '');
        });
        return () => { cancelled = true; };
    }, []);

    // Re-fetch profile when landing on home with token but no profile (e.g. after verify)
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token && location.pathname === '/' && !profileData?.data) {
            fetchProfile(true);
        }
    }, [location.pathname]);

    const capitalize = (s) => s ? s.split(' ').map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ') : s;

    const getProfileMenuLabel = () => {
        let name = '';
        if (profileData?.data) {
            const { firstName, lastName } = profileData.data;
            if (firstName && lastName) name = `${firstName} ${lastName}`;
            else if (firstName) name = firstName;
            else if (lastName) name = lastName;
        } else if (isGuest) {
            const f = localStorage.getItem('guestFirstName') || '';
            const l = localStorage.getItem('guestLastName') || '';
            name = (f + ' ' + l).trim() || 'Guest';
        }
        if (!name) return 'Your Account';
        return capitalize(name);
    };

    const accountMenuLinks = getMobileAccountMenuLinks(getProfileMenuLabel());

    function handleLogout() {
        clearAuthStorage();
        setIsLoggedIn(false);
        setHeaderToggle(false);
        navigate('/auth/login');
    }

    function handleLoginAsUser() {
        setIsLoggedIn(false);
        setHeaderToggle(false);
        navigate('/auth/login');
    }

    function handleLogoutAsGuest() {
        clearGuestData();
        setIsLoggedIn(false);
        setHeaderToggle(false);
        navigate('/');
    }

    const flatCategories = useMemo(() => {
        const list = [];
        getData(1).forEach((column) => {
            column.forEach((category) => {
                const sectionName = category[0];
                const subItems = category.slice(1);
                list.push({ sectionName, subItems });
            });
        });
        return list;
    }, []);

    // Closing: useLayoutEffect so isClosing is set before paint (keeps nav visible for animation)
    useLayoutEffect(() => {
        if (!headerToggle) {
            setCustomTransition('translateX(-100%)');
            setIsClosing(true);
        }
    }, [headerToggle]);

    // Opening: useEffect so first paint shows sidebar at -100%, then we animate to 0%
    useEffect(() => {
        if (headerToggle) {
            setIsClosing(false);
            setCustomTransition('translateX(0%)');
        }
    }, [headerToggle]);

    useEffect(() => {
        if (!headerToggle && isClosing) {
            const timer = setTimeout(() => setIsClosing(false), 300);
            return () => clearTimeout(timer);
        }
    }, [headerToggle, isClosing]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setHeaderToggle(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [setHeaderToggle]);

    function toggleCategory(index) {
        setOpenCategoryIndex((prev) => {
            const next = prev === index ? null : index;
            if (next !== prev) setOpenSubGroupKey(null);
            return next;
        });
    }

    function toggleSubGroup(catIndex, subIndex) {
        const key = `${catIndex}-${subIndex}`;
        setOpenSubGroupKey((prev) => (prev === key ? null : key));
    }

    function handleSubItemClick(sectionName, subItem) {
        navigate(`/products/${sectionName}/${subItem}`);
        setHeaderToggle(false);
    }

    function handleNavLink(path) {
        navigate(path);
        setHeaderToggle(false);
    }

    return (
        <div className="nav nav--visible" style={{ display: (headerToggle || isClosing) ? 'block' : 'none' }} data-overlay-visible={headerToggle}>
            <div className="app-nav" style={{ transform: customTransition }} ref={ref}>
                <div className="navContent">
                    <div className="sidebar-container">
                        {offerImg ? (
                        <div className="offerImg">
                            <img src={offerImg} alt="" />
                        </div>
                        ) : null}
                        <div className="nav-ul">
                            <div className="nav-products">
                                <button
                                    type="button"
                                    className={`nav-products-row nav-products-row--root${isProductsOpen ? ' nav-products-row--active' : ''}`}
                                    onClick={() => setIsProductsOpen((prev) => !prev)}
                                    aria-expanded={isProductsOpen}
                                >
                                    <span className="nav-products-row__icon" aria-hidden>
                                        <i className="bi bi-grid-3x3-gap" />
                                    </span>
                                    <span className="nav-products-row__label">All Products</span>
                                    <ChevronIcon isOpen={isProductsOpen} />
                                </button>
                                <div
                                    className={`nav-products-tree${isProductsOpen ? ' nav-products-tree--open' : ''}`}
                                >
                                    {flatCategories.map((cat, index) => {
                                        const isCatOpen = openCategoryIndex === index;
                                        return (
                                            <div
                                                key={`${cat.sectionName}-${index}`}
                                                className="nav-products-branch"
                                            >
                                                <button
                                                    type="button"
                                                    className={`nav-products-row nav-products-row--category${isCatOpen ? ' nav-products-row--active' : ''}`}
                                                    onClick={() => toggleCategory(index)}
                                                    aria-expanded={isCatOpen}
                                                >
                                                    <span className="nav-products-row__label">{cat.sectionName}</span>
                                                    <ChevronIcon isOpen={isCatOpen} small />
                                                </button>
                                                <div
                                                    className={`nav-products-tree nav-products-tree--nested${isCatOpen ? ' nav-products-tree--open' : ''}`}
                                                >
                                                    {renderCategorySubItems(cat, index, {
                                                        openSubGroupKey,
                                                        toggleSubGroup,
                                                        handleSubItemClick,
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="nav-profile-options">
                                {isLoggedIn ? (
                                    <>
                                        <p className="nav-section-label">My account</p>
                                        <ul className="nav-account-menu">
                                            {accountMenuLinks.map((item) => (
                                                <li key={item.to}>
                                                    <button
                                                        type="button"
                                                        className="nav-account-row"
                                                        onClick={() => handleNavLink(item.to)}
                                                    >
                                                        <span className="nav-account-row__icon" aria-hidden>
                                                            <i className={`bi ${item.icon}`} />
                                                        </span>
                                                        <span className="nav-account-row__body">
                                                            <span className="nav-account-row__label">{item.label}</span>
                                                        </span>
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="nav-account-logout">
                                            {isGuest ? (
                                                <div className="nav-guest-actions">
                                                    <button
                                                        type="button"
                                                        className="nav-account-logout__btn"
                                                        onClick={handleLoginAsUser}
                                                    >
                                                        Login as full user
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="nav-guest-link"
                                                        onClick={handleLogoutAsGuest}
                                                    >
                                                        End guest session
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="nav-account-logout__btn"
                                                    onClick={handleLogout}
                                                >
                                                    Logout
                                                </button>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <div className="accountInfoNonLoggedIn">
                                        <p className="newUser"><span>If you are a new user</span></p>
                                        <span className="newUserRegister" onClick={() => { setHeaderToggle(false); navigate('/auth/register'); }}>Register</span>
                                        <span className="accountBtn btn rippleWhite" onClick={() => { setHeaderToggle(false); navigate('/auth/login'); }}>Login</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}